<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.33398 6.66671H14.6673M2.66732 3.33337H13.334C14.0704 3.33337 14.6673 3.93033 14.6673 4.66671V11.3334C14.6673 12.0698 14.0704 12.6667 13.334 12.6667H2.66732C1.93094 12.6667 1.33398 12.0698 1.33398 11.3334V4.66671C1.33398 3.93033 1.93094 3.33337 2.66732 3.33337Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
